import { Outlet } from "react-router";
import { WorkspaceScreen } from "../../workspace/components/WorkspaceScreen";
import { useAuthenticated } from "../../authn";
import { UnauthorizedMessage } from "../../shared/components";

export function PlatformAnalyticsLayout() {
  const auth = useAuthenticated();
  // usePermissions() requires OrgProvider context which is unavailable here
  const isProvisioner =
    auth.state === "authenticated" &&
    (import.meta.env.DEV || auth.roles.includes("AgenticProvisioner"));

  if (!isProvisioner) {
    return (
      <WorkspaceScreen>
        <UnauthorizedMessage />
      </WorkspaceScreen>
    );
  }

  return (
    <WorkspaceScreen wide>
      <Outlet />
    </WorkspaceScreen>
  );
}
